import mutations from './dataManagementProcess.mutations'
import actions from './dataManagementProcess.actions'
import getters from './dataManagementProcess.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
